import { HttpClient } from '@angular/common/http';
import { HttpUtils } from '../utils/httpUtils';
import { Injectable } from '@angular/core';
import { InternalEquipmentCustomField } from '../model/internalEquipmentCustomField';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable()
export class InternalEquipmentCustomFieldsService {

    readonly baseUrl = `${environment.equipmentUrl}/internalEquipmentCustomFields`;

    constructor(private http: HttpClient) {
    }

    findAllTypes(): Observable<any> {
        const url = environment.coreUrl + '/internalEquipmentCustomFields/fieldTypes';

        return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    findAll(): Observable<any> {
        const url = `${this.baseUrl}/`;

        return this.http.post(url,{}).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    findOne(id: number): Observable<any> {
        const url = environment.coreUrl + `/internalEquipmentCustomFields/${id}`;

        return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    save(field: InternalEquipmentCustomField): Observable<any> {
        const url = `${this.baseUrl}/create`;

        return this.http.post(url, field).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    delete(field: InternalEquipmentCustomField): Observable<any> {
        const url = `${this.baseUrl}/internalEquipmentCustomFields/${field.id}`;

        return this.http.delete(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    findAllWithContent(): Observable<any> {
        const url = `${this.baseUrl}/`;

        return this.http.post(url,{}).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }
}
